
const fullApiUrl = 'https://integratedservices.amr.net/copaapi/api/';

// const fullApiUrl = 'https://localhost:44326/api/';

export { fullApiUrl };